import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1812_915"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1812_915)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.21941 0.804183C1.82888 0.413659 1.19572 0.413659 0.805192 0.804183C0.414668 1.19471 0.414668 1.82787 0.805192 2.2184L6.42405 7.83725L0.8651 13.3962C0.474576 13.7867 0.474576 14.4199 0.8651 14.8104C1.25562 15.2009 1.88879 15.2009 2.27931 14.8104L7.83826 9.25146L13.4571 14.8703C13.8476 15.2608 14.4808 15.2608 14.8713 14.8703C15.2619 14.4798 15.2619 13.8466 14.8713 13.4561L9.25248 7.83725L14.8114 2.2783C15.2019 1.88778 15.2019 1.25462 14.8114 0.864091C14.4209 0.473566 13.7877 0.473567 13.3972 0.864091L7.83826 6.42304L2.21941 0.804183Z"
        fill="#27272C"
      />
    </g>
  </svg>
);
export default SvgClose;
